import { render } from "./Footer.vue?vue&type=template&id=4a48065b"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=4a48065b&lang=css"
script.render = render

export default script